<template>
  <div>
    <b-form-group
      label="Versiyon Türü"
      label-for="version_type"
    >
      <validation-provider
        #default="{ errors }"
        name="Versiyon Türü"
        rules="required"
      >
        <v-select
          v-model="dataItem.versionOptions.version_type"
          :options="dataList"
          label="title"
          :reduce="item => item.id"
          placeholder="Versiyon Türü"
        />
        <small class="text-danger">{{ errors[0] }}</small>
        <small class="text-secondary"><b>Yeni doküman yükleneceği zaman</b> veya <b>alfa güncellemelerinde</b> değişiklik türü olarak belirtilir.</small>
      </validation-provider>
    </b-form-group>
    <div class="border p-1 bg-light border-light rounded mb-2 pb-0 position-relative">
      <ul class="list-unstyled mb-0 font-small-3">
        <li><strong>Ana Versiyon:</strong> Büyük ve köklü değişikliklerin yapıldığı versiyonlardır. Geriye dönük uyumluluk genellikle yoktur.</li>
        <li><strong>Alt Versiyon:</strong> Orta seviyede geliştirme ve iyileştirmelerin yapıldığı versiyonlardır. Geriye dönük uyumluluk korunur.</li>
        <li><strong>Mini Düzeltme:</strong> Yeni özellik içermeyen, küçük hata ve teknik sorunların giderildiği versiyonlardır.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BButton,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'PFilesVOVTSelectCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return [
        {
          id: 'major',
          title: 'Ana Versiyon',
        },
        {
          id: 'minor',
          title: 'Alt Versiyon',
        },
        {
          id: 'patch',
          title: 'Düzeltme',
        },
      ]
    },
    dataItem() {
      return this.$store.getters['productFiles/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
